import type { ReactNode } from 'react';
import { Card } from 'react-bootstrap';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import { getHelpHtml } from '../../utils/help/help-content';

export function SettingsCard({
  title,
  helpKey,
  description,
  action,
  children,
  className = '',
}: {
  title: string;
  helpKey?: string;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  const helpHtml = helpKey ? getHelpHtml(helpKey) : '';

  return (
    <Card className={`shadow-sm ${className}`}>
      <Card.Header className="d-flex align-items-start justify-content-between gap-3">
        <div className="min-w-0">
          <h2 className="d-inline-flex align-items-center gap-2 fw-semibold text-1000 fs-0 mb-0">
            {title}
            {helpHtml ? <HelpTooltip html={helpHtml} /> : null}
          </h2>
          {description && <p className="mt-1 fs--1 text-700 mb-0">{description}</p>}
        </div>
        {action && <div className="flex-shrink-0">{action}</div>}
      </Card.Header>
      <Card.Body>{children}</Card.Body>
    </Card>
  );
}
